import { cursorPaginationFieldPolicy } from '../../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../../utils/types/TypePolicies';

function keyArgsForUnfilteredResults(
  defaultArgs: Array<string | Array<string>>,
  fieldAlias: string | undefined
) {
  /**
   * @note We conditionally set the cache keys of both `indirectMemberships` and `directMemberships`
   * to include the `page.first` argument for aliased queries in order to separate their results.
   */
  if (fieldAlias?.startsWith('unfiltered')) {
    return ['page', ['first'], ...defaultArgs];
  }

  return defaultArgs;
}

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      indirectMemberships: cursorPaginationFieldPolicy(
        (__args, { field, variables }) => {
          const filterArgs = ['grantingResource'];

          if (typeof variables?.searchTerm !== 'undefined') {
            filterArgs.push('query');
          }

          const baseArgs = ['$resourceId', 'filter', filterArgs];

          return keyArgsForUnfilteredResults(baseArgs, field?.alias?.value);
        }
      ),
      directMemberships: cursorPaginationFieldPolicy(
        (__args, { field, variables }) => {
          let baseArgs: Array<string | Array<string>> = ['$resourceId'];

          if (typeof variables?.searchTerm !== 'undefined') {
            baseArgs = baseArgs.concat(['filter', ['query']]);
          }

          return keyArgsForUnfilteredResults(baseArgs, field?.alias?.value);
        }
      ),
    },
  },
};
